import styled from "styled-components";

export const BackdropStyle = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(68, 68, 68, 0.75);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;